import api from '../../libs/api'
import { getP } from 'redux-polyglot'

/**
 * Actions for initializing the application
 */
export const INIT_APP_REQUEST = 'TICKETS/INIT_APP_REQUEST'

const initAppRequest = () => ({
  type: INIT_APP_REQUEST
})

export const initApp = () => dispatch => {
	
	  return Promise.all([
    	dispatch(initAppRequest()),
    	dispatch(loadTickets())
  		])
}


export const FETCH_TICKETS_REQUEST = 'TICKETS/FETCH_TICKETS_REQUEST'
export const FETCH_TICKETS_SUCCESS = 'TICKETS/FETCH_TICKETS_SUCCESS'
export const FETCH_TICKETS_FAILURE = 'TICKETS/FETCH_TICKETS_FAILURE'

export const fetchTicketsRequest = () => ({
	type: FETCH_TICKETS_REQUEST
})

export const fetchTicketsSuccess = (ticketsContainer) => {
	
	let tickets = []
	if (ticketsContainer.length > 0) {
		ticketsContainer.forEach((ticket) => {
			tickets.push({
				id: ticket.id,
				user_id: ticket.user_id,
				title: ticket.ticket_title,
				description: ticket.ticket_description,
				status:ticket.ticket_status,
				timestamp:ticket.ticket_timestamp,
				user_timestamp:ticket.last_comment_timestamp,
				username:ticket.user_username,
				user_image:ticket.user_image.small,
				last_comment_user_image:ticket.last_comment_user_image.small,
				last_comment_user_id:ticket.last_comment_user_id
	 		})
		})
	}

	return {
		type: FETCH_TICKETS_SUCCESS,
		payload: {
			tickets
		}
	}
}

export const fetchTicketsFailure = (error) => ({
	type: FETCH_TICKETS_FAILURE,
	payload: error instanceof Error? error : new Error(error),
	error:true
})
export const FOCUS_TICKET = 'TICKETS/FOCUS_TICKET'
export const focusTicket = (id) => ({
  type: FOCUS_TICKET,
  payload: {
    id
  }
})
export const FOCUS_TICKET_POSITION = 'TICKETS/FOCUS_TICKET_POSITION'
export const focusTicketPosition = (position) => ({
  type: FOCUS_TICKET_POSITION,
  payload: {
    position
  }
})

export const SELECT_TICKET = 'TICKETS/SELECT_TICKET'
export const selectTicketRequest = (id) => ({
	type:SELECT_TICKET,
	payload:{
		id
	}
})

export const selectTicket = id => (dispatch, getState) => {
	    dispatch(selectTicketRequest(id))
}

export const NEW_SUPPORT_TICKET = 'TICKETS/NEW_SUPPORT_TICKET'

const newTicket = () => ({
  type: NEW_SUPPORT_TICKET
})

export const newSupportTicket = () => (dispatch, getState) => {
	    dispatch(newTicket())
}

export const loadTickets = () => (dispatch, getState) => {
	dispatch(fetchTicketsRequest())
	return api.getTickets()
		.then(res =>  res.json())
		.then(response => {
	          if (response.status === 200) {
	            return dispatch(fetchTicketsSuccess(response.tickets))
	          } else {
	            return dispatch(fetchTicketsFailure(response.reason))
	          }
	        },
	        () =>  dispatch(fetchTicketsFailure(getP(getState()).t("support_app.error_loading_tickets",{_:'An error occurred while retrieving tickets'})))
		)
}

export const DISMISS_TICKETS_ERROR = 'TICKETS/DISMISS_TICKETS_ERROR'

const dismissTicketsError = () => ({
  type: DISMISS_TICKETS_ERROR
})
export const dismissError = () => (dispatch, getState) => {
	   dispatch(dismissTicketsError())
}